import React from "react";
import { FiCopy } from "react-icons/fi";

import { copyTextToClipboard } from "utils/dom";

import "./CopyIcon.scss";

interface CopyIconProps {
  copyText?: string | null;
  label: string;
  iconSize?: number;
}

const CopyIcon = ({ copyText, label, iconSize = 14 }: CopyIconProps) => {
  if (!copyText) {
    return null;
  }

  const copy = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    copyTextToClipboard(copyText, label);
  };

  return (
    <span
      className="copy-icon"
      role="button"
      tabIndex={0}
      aria-label={`Copy ${label}`}
      title={`Copy ${label}`}
      onClick={copy}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          copy(e);
        }
      }}
    >
      <FiCopy size={iconSize} stroke={"#1D99A9"} strokeWidth={"1.5"} />
    </span>
  );
};

export default CopyIcon;
